module.exports = __webpack_public_path__ + "img/green-key.37a68eb9.png";